module.exports = __webpack_public_path__ + "static/img/gggggg_25.0d1fe4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_25.png
// module id = 7M4k
// module chunks = 1